// src/layout/MainLayout.jsx
import Topbar from "./Topbar";
import Sidebar from "./Sidebar";
import { Outlet } from "react-router-dom"; // ✅ Importa Outlet

export default function MainLayout() {
  return (
    <div style={styles.container}>
      <Sidebar />
      <div style={styles.main}>
        <Topbar />
        <div style={styles.content}>
          <Outlet /> {/* ✅ Aquí se renderizan Dashboard, Clientes, OLTs, etc */}
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: "flex",
    height: "100vh",
  },
  main: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#f1f5f9",
  },
  content: {
    padding: 16,
    overflowY: "auto",
    flex: 1,
  },
};
